<template>
	<div class="situation-news-details">
		<div class="title">
			<span>基地动态</span>
			<span class="viewCount">发布日期：{{newsDetails.createTime}}&nbsp;&nbsp;&nbsp;&nbsp;浏览次数：45次</span>
		</div>
		<el-divider></el-divider>
		<div class="details-text">
			<iframe class="file-html" :src="'/file/news/'+newsDetails.id+'.html'" frameborder="0"></iframe>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			newsDetails: {
				type: Object
			}
		},
		created() {
			// console.log(this.newsDetails)
		}
	}
</script>

<style lang="scss">
	.situation-news-details {

		.title {
			line-height: 50px;
			font-weight: bold;

			.viewCount {
				float: right;
				color: #4b4b4b;
				font-size: 14px;
				font-weight: 100;
			}
		}

		.el-divider {
			margin: 0;
			margin-bottom: 20px;
		}

		.details-text {
			.file-html {
				height: calc(100vh - 150px);
				width: 100%;
			}
		}
	}
</style>